












































import { Component, Vue } from 'vue-property-decorator';
import { IFacetValue, IExtendedFacetValue, IFilter } from '../Scripts/ISearchService';
import { FilterHelper } from '../Scripts/FilterHelper';

import ActionTracker, { FacetSelectedEvent } from '../Scripts/AnalyticsEvents';
import AppConfig from '../Scripts/AppConfig';

import RemoteHelp from './RemoteHelp.vue';

@Component({
	components: { RemoteHelp }
})
export default class FacetAcademicPeriod extends Vue {
	get helpTarget (): string {
		return 'button-term';
	}

	get helpTitle (): string {
		return 'Academic Period';
	}

	get helpModalId (): string {
		return 'academicterm-modal';
	}

	get relevantFilter (): IFilter | undefined {
		return this.$store.state.filters.find((f: IFilter) => f.key === 'yearTerm');
	}

	get selectedPeriod (): string {
		var current = this.relevantFilter !== undefined && this.relevantFilter.value;
		return current || AppConfig.defaultPeriod;
	}

	set selectedPeriod (value: string) {
		// nothing to do; hiding error caused by two way binding
		// trying to write when the radio is selected. Was having trouble
	}

	public isSelected (item: IFacetValue): boolean {
		return this.selectedPeriod === item.value;
	}

	get values (): IExtendedFacetValue[] {
		var facets = this.$store.state.currentTermList as IFacetValue[];

		return AppConfig.periods.reduce((result, p) => {
			const facet = facets.find((f) => f.value === p.period);

			if (facet) {
				result.push({ count: facet.count, value: p.period, display: p.period, relevant: p.relevant } as IExtendedFacetValue);
			}

			return result;
		}, [] as IExtendedFacetValue[]);
	}

	get topValues (): IFacetValue[] {
		return this.values.filter((o) => o.relevant);
	}

	get otherValues (): IFacetValue[] {
		return this.values.filter((o) => !o.relevant);
	}

	get more (): boolean {
		return this.otherValues.length > 0;
	}

	public explore (): void {
		this.$store.commit('toggleAcademicPeriodExpanded');
	}

	get isExpanded (): boolean {
		return this.$store.state.academicPeriodExpanded;
	}

	public toogleSelected (item: IFacetValue): void {
		const helper = new FilterHelper(this.$router);

		if (this.isSelected(item)) {
			// nothing to do
		} else {
			ActionTracker.track(new FacetSelectedEvent('term', item.value));
			helper.setFilter('term', item.value);
		}
	}
}
